import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import UMSG_TYPE from 'constants/umsg/type.const';
import endpoint from 'utils/backend/endpoint.util';
import actionBe from 'utils/mw/actionBe.util';

const beDepositRefundInfo = actionBe('beDepositRefundInfo', ({ AT, ATAG, clientId, amount, source }) =>
  endpoint(H.get, 'deposit/:salonId/client/:clientId/refund/info/?requested_amount=:amount&source=:source', {
    base: CONF.transactionApiRoot,
    AT,
    name: ATAG,
    params: { clientId, amount, source },
    umsg: UMSG_TYPE.global,
  }),
);

// noinspection JSUnusedGlobalSymbols
export default beDepositRefundInfo;
